//
//
//
//
//
//
//

import WorkNav from "./componets/WorkNav";
import util from '@/lib/util';

export default {
    name: "workSheets",
    components: {
        WorkNav,
    },
    data() {
        return {

        }
    },
    methods: {


    },
    created() {

    }
};
